import { SortType } from 'utils/constants/common';

import { Act, setActs, setSortActs } from 'store/models/acts';
import { AppThunkAction } from 'store/utils';

type SortFunc = (actA: Act, actB: Act, sortBy: keyof Act) => number;

export const sortActs =
    (sortBy: keyof Act): AppThunkAction<void> =>
    (dispatch, getState) => {
        const { acts, sorts } = getState().acts;
        const newActs = acts.slice();
        const newSort = sorts.get(sortBy) === SortType.ASC ? SortType.DESC : SortType.ASC;
        const compare: SortFunc =
            newSort === SortType.ASC
                ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  (itemA, itemB, sortBy) => (itemA[sortBy]! > itemB[sortBy]! ? 1 : -1)
                : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  (itemA, itemB, sortBy) => (itemA[sortBy]! < itemB[sortBy]! ? 1 : -1);
        newActs.sort((actA, actB) => compare(actA, actB, sortBy));
        sorts.set(sortBy, newSort);
        const newSorts = new Map(sorts);
        dispatch([setActs(newActs), setSortActs(newSorts)]);
    };
